import cookie from 'js-cookie';

export const ConvertToSessionCookie = (cookieName: any) => {
    const COOKIE_PATH: string = '/';
    const existingCookieValue: string | undefined = cookie.get(cookieName);

    if (existingCookieValue) {
        cookie.set(cookieName, existingCookieValue, {
            path: COOKIE_PATH
        });

        console.log(`Cookie '${cookieName}' converted to a session cookie.`);
        return existingCookieValue;
    } else {
        console.log(`Cookie '${cookieName}' not found.`);
        return null;
    }
};